import { __assign } from "tslib";
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BasicUserName from '../../../User/BasicUserName';
import UserAvatar from '../../../User/Avatar';
import PinIcon from '@wix/da-ds/pkg/Icons/24x24/Pin';
import GraduationCap from '@wix/da-ds/pkg/Icons/16x16/GraduationCap';
import { grouphubId } from '../../redux/constants';
import Flex from '@wix/da-ds/pkg/Flex';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '../../../types/resource';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
import s from './NetworkBarGroupLink.scss';
var NetworkBarGroupLink = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var group = _a.group, isSelected = _a.isSelected, _k = _a.isCollapsed, isCollapsed = _k === void 0 ? false : _k, tabIndex = _a.tabIndex, rank = _a.rank, togglePinGroup = _a.togglePinGroup, unrecommendGroup = _a.unrecommendGroup, className = _a.className;
    var t = useTranslation().t;
    var isGroupHub = group.userId === grouphubId;
    var menuItems = useMemo(function () {
        var _a, _b, _c;
        var menuItemBi = {
            evid: BiEventType.NETWORK_BAR_3DOTS_SELECT,
            itemid: group.userId,
            typeid: ResourceType.GROUP,
            indicator: ((_a = group.networkbar) === null || _a === void 0 ? void 0 : _a.hasNewContent) ? 1 : 0,
            rank: rank,
        };
        return [
            group.isWatching &&
                !isGroupHub &&
                (((_b = group.networkbar) === null || _b === void 0 ? void 0 : _b.isPinned)
                    ? {
                        label: t('networkBar.groups.group.actions.unpin'),
                        onClick: function () { return togglePinGroup(group.userId, false); },
                        biData: __assign(__assign({}, menuItemBi), { menu_item: 'unpin' }),
                    }
                    : {
                        label: t('networkBar.groups.group.actions.pin'),
                        onClick: function () { return togglePinGroup(group.userId, true); },
                        biData: __assign(__assign({}, menuItemBi), { menu_item: 'pin' }),
                    }),
            ((_c = group.extendedGroup) === null || _c === void 0 ? void 0 : _c.isAdmin) && {
                label: t('networkBar.groups.group.actions.notifications'),
                link: Url.groupNotificationsLink(group.userId),
                biData: {
                    evid: BiEventType.VIEW_GROUP_NOTIFICATION,
                    typeid: ResourceType.GROUP,
                    itemid: group.userId,
                    groupid: group.useridUuid,
                    sectionname: 'menu',
                },
            },
            {
                label: t('networkBar.groups.group.actions.visit'),
                link: Url.userLink(group.username),
                biData: {
                    evid: BiEventType.USERNAME_CLICK,
                    sectionname: 'sidebar',
                    itemid: group.userId,
                    typeid: ResourceType.GROUP,
                },
            },
            !group.isWatching &&
                !isGroupHub && {
                label: t('networkBar.groups.group.actions.unrecommend'),
                onClick: function () { return unrecommendGroup(group.userId); },
                biData: __assign(__assign({}, menuItemBi), { menu_item: 'unrecommend' }),
            },
        ];
    }, [
        group.isWatching,
        group.networkbar,
        group.userId,
        group.useridUuid,
        group.username,
        group.extendedGroup,
        rank,
        t,
        togglePinGroup,
        unrecommendGroup,
        isGroupHub,
    ]);
    // custom group icon for GroupHub
    var groupAvatarUser = isGroupHub
        ? __assign(__assign({}, group), { usericon: 'https://st.deviantart.net/eclipse/global/svg/grouphub.svg?1' }) : group;
    var PinIconComponent = isGroupHub ? GraduationCap : PinIcon;
    var url = isGroupHub
        ? Url.userLink(group.username)
        : ((_b = group.networkbar) === null || _b === void 0 ? void 0 : _b.url) || Url.browseGroupFeedLink(group.username);
    return (React.createElement(NetworkBarItem, { url: url, icon: React.createElement(UserAvatar, { user: groupAvatarUser, size: 24, className: classnames(isGroupHub && s['grouphub']), avatarClassName: classnames(isGroupHub && s['grouphub-avatar']), withLink: false }), tooltipContent: React.createElement(Flex, { alignItems: "center" },
            group.username,
            ((_c = group.networkbar) === null || _c === void 0 ? void 0 : _c.isPinned) && (React.createElement(PinIconComponent, { size: IconSize.TINY, disableDefaultColors: true, className: s['pin-icon'] }))), className: classnames(s['root'], isCollapsed && s['collapsed'], isSelected && s['selected'], className), linkClassName: classnames(s['group-link'], (((_d = group.networkbar) === null || _d === void 0 ? void 0 : _d.isPinned) || ((_e = group.extendedGroup) === null || _e === void 0 ? void 0 : _e.isAdmin)) &&
            s['has-pin']), menuClassName: s['actions'], iconClassName: s['avatar'], isCollapsed: isCollapsed, isSelected: isSelected, hasNewContent: (_f = group.networkbar) === null || _f === void 0 ? void 0 : _f.hasNewContent, tabIndex: tabIndex, menuItems: menuItems, biData: {
            evid: BiEventType.NETWORK_BAR_NAV_CLICK,
            itemid: group.userId,
            typeid: ResourceType.GROUP,
            indicator: ((_g = group.networkbar) === null || _g === void 0 ? void 0 : _g.hasNewContent) ? 1 : 0,
            rank: rank,
            is_expanded: isCollapsed ? 0 : 1,
        }, menuBiData: {
            evid: BiEventType.NETWORK_BAR_3DOTS_OPEN,
            itemid: group.userId,
            typeid: ResourceType.GROUP,
            indicator: ((_h = group.networkbar) === null || _h === void 0 ? void 0 : _h.hasNewContent) ? 1 : 0,
            rank: rank,
        } },
        ((_j = group.networkbar) === null || _j === void 0 ? void 0 : _j.isPinned) && (React.createElement(PinIconComponent, { size: IconSize.SMALLER, disableDefaultColors: true })),
        React.createElement("span", { className: s['username'] },
            React.createElement(BasicUserName, { user: group, showSymbol: false }))));
};
NetworkBarGroupLink.displayName = 'NetworkBarGroupLink';
export default NetworkBarGroupLink;
//# sourceMappingURL=NetworkBarGroupLink.js.map